module.exports = new __parcel__URL__("filter-empty.4c92f05b.svg").toString();